<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
  >
    <circle
      :fill="color.border"
      cx="16"
      cy="16"
      r="16"
    />
    <g
      v-html="icon.svg.replace('<svg ', `<svg x='6' y='6' fill='#ffffff' width='20' height='20' `)"
    />
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: Object,
      required: true,
      default() {
        return {
          border: '#725794',
          bec: '#dd6418',
        };
      },
    },
    icon: {
      type: Object,
      required: true,
      default() {
        return {
          fa: 'fighter-jet',
          svg: '',
        };
      },
    },
  },
};
</script>
